import { IconInfoCircle } from '@justeattakeaway/pie-icons-react';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIENotification, {
  IPieNotificationMode,
} from '@src/shared/components/PIENotification';
import PIEText from '@src/shared/components/PIEText';
import React, { FC } from 'react';

interface IUpcommingDeliveryInformationProps {
  comment: string;
}

export const UpcommingDeliveryInformation: FC<
  IUpcommingDeliveryInformationProps
> = ({ comment }) => {
  return (
    <PIENotification
      isOpen={true}
      showClose={false}
      mode={IPieNotificationMode.Info}
      modInline={true}
      icon={
        <PIEComponentUtil marginRight="-3px">
          <IconInfoCircle size={'m'} />
        </PIEComponentUtil>
      }
    >
      <PIEText
        text={comment}
        size="var(--xds-font-size-16)"
        fontWeight="var(--xds-font-weight-regular)"
        color="var(--xds-color-content-default)"
      />
    </PIENotification>
  );
};

export default UpcommingDeliveryInformation;
